var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-select',{ref:"select",attrs:{"input-size":_vm.inputSize,"emit-only-value":false,"async":"","parse-callback":_vm.parse,"search-data":_vm.search},on:{"input":(v) => _vm.$emit('input', v)},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }